import { SET_FAVORITE } from "../constant";

const FavoriteReducer = (state = {}, action) => {
    switch (action.type) {
        case SET_FAVORITE:
            return {
                ...state,
                data: action.data
            }
        default:
            return state
    }
}

export default FavoriteReducer